class EcoFriendlyPackage extends HTMLElement {


	constructor() {
		super();
		this.checkbox = this.querySelector('input[type="checkbox"]');
		this.debouncedOnChange = debounce((event) => { this.onChange(event) }, 300);
		this.addEventListener('change', this.debouncedOnChange.bind(this));
		this.checkPackage();
	}


	async getCart() {
		const result = await fetch("/cart.json");
		if (result.status === 200) {
			return result.json();
		}
		throw new Error(`Failed to get request, Shopify returned ${result.status} ${result.statusText}`);
	}


	async setCartAttributes(attributes = {}) {
		const result = await fetch("/cart/update.json", {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
				"Accept": "application/json"
			},
			body: JSON.stringify({
				attributes: attributes
			})
		});
		return result.json();
	}


	onChange(event) {
		if (this.checkbox.checked) {
			let obj = { "ECO_FRIENDLY_PACKAGE": "YES" };
			JSON.stringify(obj);
			(async () => { await this.setCartAttributes(obj); this.renderCart() })()
		} else {
			let obj = { "ECO_FRIENDLY_PACKAGE": "NO" };
			JSON.stringify(obj);
			(async () => { await this.setCartAttributes(obj); this.renderCart() })()
		}
	}


	getSectionsToRender() {
		return [
			{ id: 'cart-drawer', section: '#CartDrawer', selector: '.drawer-inner' }
		];

	}


	renderCart() {
		this.getSectionsToRender().forEach((section) => {
			fetch(window.Shopify.routes.root + `/?section_id=${section.id}`)
				.then(response => response.text())
				.then((responseText) => {
					let html = responseText;
					let elementToReplace = document.querySelector(`${section.selector}`);
					let replaceWith = new DOMParser().parseFromString(html, 'text/html').body.querySelectorAll(`${section.selector} > *`);
					elementToReplace.innerHTML = ''
					replaceWith.forEach((element) => { elementToReplace.appendChild(element) })
				});
		});
	}


	checkPackage() {
		(async () => {
			let findAttribute = await this.getCart();
			//console.log('findAttribute ECO_FRIENDLY_PACKAGE', findAttribute)
			if (findAttribute.attributes.hasOwnProperty('ECO_FRIENDLY_PACKAGE')) {
				findAttribute.attributes['ECO_FRIENDLY_PACKAGE'] === "YES" ? this.checkbox.checked = true : this.checkbox.checked = false;
			} else {
				this.checkbox.checked = false;
			}
		})()
	}


}
customElements.define('eco-package', EcoFriendlyPackage);